/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useBranchCourseContext } from "../Components/BranchCourseDataContext";

export function BranchCourseCallEnrollOffDialog({
  history,
  id,
  active_value,
  show,
  onHide,
}) {
  const context = useBranchCourseContext();
  // Branch Context

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const callEnrollOff = async () => {
    const callToEnrollOffUrl = "api/branch-course/enroll-off/";

    //turn call to enroll off for branch course post
    const result = await axios.patch(callToEnrollOffUrl + id);
    if (result.data === "success") {
      // console.log("COE off");
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/branch-course/branch-course-list");
      }, 1000);
    } else {
    }
    // closing delete modal
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Turn Call to Enroll Off
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to turn call to enroll off?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={callEnrollOff}
            className="btn btn-delete btn-elevate"
          >
            Turn Off
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
